import type { CabMeetingFormData } from '../types/cabMeeting';

export type CabMeetingFormErrors = Partial<
  Record<keyof CabMeetingFormData | 'dateTimeRange', string>
>;

export function validateCabMeetingForm(data: CabMeetingFormData): CabMeetingFormErrors {
  const errors: CabMeetingFormErrors = {};

  if (!data.name.trim()) {
    errors.name = 'Name is required';
  } else if (data.name.trim().length > 255) {
    errors.name = 'Name must be 255 characters or fewer';
  }

  if (!data.status) {
    errors.status = 'State is required';
  }

  if (!data.cabManager) {
    errors.cabManager = 'CAB Manager is required';
  }

  if (!data.meetingStart) {
    errors.meetingStart = 'Meeting Start Time is required';
  }

  if (!data.meetingEnd) {
    errors.meetingEnd = 'Meeting End Time is required';
  }

  if (data.meetingStart && data.meetingEnd) {
    const start = new Date(data.meetingStart);
    const end = new Date(data.meetingEnd);
    if (!Number.isNaN(start.getTime()) && !Number.isNaN(end.getTime()) && end <= start) {
      errors.dateTimeRange = 'Meeting End Time must be later than Meeting Start Time';
    }
  }

  return errors;
}

export function hasCabMeetingValidationErrors(errors: CabMeetingFormErrors): boolean {
  return Object.keys(errors).length > 0;
}
